<ng-container *ngIf="!!get && !!form" [formGroup]="form">
    <tt-select
        *ngIf="get.setting_show_oh_head_deliveryterm_no !== '0'"
        ttLabel="deliveryterm_no"
        formControlName="deliveryterm_no"
        [ttData]="deliveryTerms"
        ttDataId="item_id"
        ttDataName="item_name"
    ></tt-select>
    <tt-checkbox *ngIf="get.setting_show_oh_head_freight_paid_by !== '0'" ttLabel="freight_paid_by" formControlName="freight_paid_by"></tt-checkbox>
    <tt-input-number
        *ngIf="form.controls.freight_paid_by.value == '1' && get.setting_show_oh_head_freight_cost_ordval !== '0'"
        ttLabel="freight_cost_ordval"
        formControlName="freight_cost_ordval"
        ttTextAlign="right"
        ttDecimals="2"
    ></tt-input-number>
    <tt-input-number
        *ngIf="get.show_oh_head_freight_cost_ordval_agreed === '1'"
        ttLabel="freight_cost_ordval_agreed"
        formControlName="freight_cost_ordval_agreed"
        ttTextAlign="right"
        ttDecimals="2"
    ></tt-input-number>
    <tt-input *ngIf="get.show_oh_head_custbonusdeal === '1'" ttLabel="custbonusdeal" formControlName="custbonusdeal" ttReadonly></tt-input>
    <tt-checkbox *ngIf="get.setting_show_oh_head_carriers_paid_by_customer !== '0'" ttLabel="carriers_paid_by_customer" formControlName="carriers_paid_by_customer"></tt-checkbox>
    <tt-select *ngIf="get.setting_show_oh_head_payment_id !== '0'" ttLabel="payment" formControlName="payment_id" [ttData]="payments" ttDataId="item_id" ttDataName="item_name"></tt-select>
    <tt-select *ngIf="get.setting_show_oh_head_factoring_no !== '0'" ttLabel="factoring" formControlName="factoring_no" [ttData]="factorings" ttDataId="item_id" ttDataName="item_name"></tt-select>
    <tt-select *ngIf="get.setting_show_oh_head_pricelist_id !== '0'" ttLabel="pricelist" formControlName="pricelist_id" [ttData]="pricelists" ttDataId="item_id" ttDataName="item_name" ttShowClearButton></tt-select>
    <tt-select *ngIf="get.setting_show_oh_head_pricelist_id2 !== '0'" ttLabel="pricelist2" formControlName="pricelist_id2" [ttData]="pricelists" ttDataId="item_id" ttDataName="item_name" ttShowClearButton></tt-select>
    <tt-select
        *ngIf="get.setting_show_oh_head_purchase_pricelist_id !== '0'"
        ttLabel="purchase_pricelist"
        formControlName="purchase_pricelist_id"
        [ttData]="pricelists"
        ttDataId="item_id"
        ttDataName="item_name"
        ttShowClearButton
    ></tt-select>
    <tt-select
        *ngIf="get.setting_show_oh_head_purchase_pricelist_id2 !== '0'"
        ttLabel="purchase_pricelist2"
        formControlName="purchase_pricelist_id2"
        [ttData]="pricelists"
        ttDataId="item_id"
        ttDataName="item_name"
        ttShowClearButton
    ></tt-select>
    <tt-select *ngIf="get.setting_show_oh_head_tax_keyno !== '0'" ttLabel="tax" formControlName="tax_keyno" [ttData]="taxes" ttDataId="item_id" ttDataName="item_name"></tt-select>
    <tt-select
        *ngIf="get.setting_show_oh_head_invoicemethod_no !== '0'"
        ttLabel="invoicemethod"
        formControlName="invoicemethod_no"
        [ttData]="invoiceMethods"
        ttDataId="invoicemethod_no"
        ttDataName="invoicemethod_name"
    ></tt-select>
    <tt-select *ngIf="get.setting_show_oh_head_order_valuta_id !== '0'" ttLabel="order_valuta_id" formControlName="order_valuta_id" [ttData]="valutas" ttDataId="valuta_id" ttDataName="valuta_name">
        <ng-container buttons>
            <tt-form-field-button
                ttIcon="fas fa-chevron-right"
                ttTooltip="goto_valuta"
                [ttTranslateTooltip]="true"
                ttGoto="valuta"
                [ttGotoParms]="{ valuta_id: form.controls.order_valuta_id.value }"
            ></tt-form-field-button>
        </ng-container>
    </tt-select>
    <tt-select
        *ngIf="get.setting_show_oh_head_invoice_valuta_id !== '0'"
        ttLabel="invoice_valuta_id"
        formControlName="invoice_valuta_id"
        [ttData]="valutas"
        ttDataId="valuta_id"
        ttDataName="valuta_name"
    >
        <ng-container buttons>
            <tt-form-field-button
                ttIcon="fas fa-chevron-right"
                ttTooltip="goto_valuta"
                [ttTranslateTooltip]="true"
                ttGoto="valuta"
                [ttGotoParms]="{ valuta_id: form.controls.invoice_valuta_id.value }"
            ></tt-form-field-button>
        </ng-container>
    </tt-select>
    <tt-select
        *ngIf="get.show_oh_head_special_discount2 === '1'"
        ttLabel="special_discount2"
        formControlName="special_discount2_keyno"
        [ttData]="discount2s"
        ttDataId="special_discount2_keyno"
        ttDataName="discount_name"
    ></tt-select>
    <tt-select *ngIf="get.show_oh_head_collection === '1'" ttLabel="collection" formControlName="collection_keyno" [ttData]="collections" ttDataId="item_id" ttDataName="item_name">
        <ng-container buttons>
            <tt-form-field-button ttIcon="fas fa-bars" ttTooltip="goto_collections" [ttTranslateTooltip]="true" ttGoto="collections"></tt-form-field-button>
        </ng-container>
    </tt-select>
</ng-container>
